<template>
  <div class="project-detail">
    <h3 align="center" class="mt-3">Edit Project Detail</h3>

    <!-- TODO: there is a lot of layout here, break this into smaller components -->
    <b-form @submit="onSubmit">
      <b-tabs content-class="mt-3">
        <b-tab title="English" active
          ><div class="px-3">
            <b-form-group
              id="input-group-name"
              label="Project name:"
              label-for="input-name"
            >
              <b-form-input
                id="input-name"
                v-model="form.project_name"
                value="getProjectDetails.project_name"
                type="text"
                placeholder="Enter project name"
              ></b-form-input>
            </b-form-group>
          </div>
          <div style="background-color: #93dce6" class="p-3">
            <b-form-group
              id="input-group-image-url"
              label="Project Image Url:"
              label-for="input-image-url"
              description="The projects Image Url!!"
            >
              <b-form-input
                id="input-image-url"
                v-model="form.project_image_url"
                value="getProjectDetails.project_image_url"
                type="text"
                placeholder="Enter project image Url"
                disabled
              ></b-form-input>
            </b-form-group>
            <b-form-file
              id="input-image"
              v-model="file1"
              placeholder="Choose an image file"
            ></b-form-file>
            <div class="mt-3">
              Selected file: {{ file1 ? file1.name : "" }}<br />
              <v-btn @click="uploadImage" color="#E5AE2E" dark>Upload</v-btn>
            </div>
          </div>
          <div class="p-3">
            <b-form-group
              id="input-group-description-eng"
              label="Description English"
              label-for="input-description_eng"
            >
              <b-form-textarea
                id="input-description_eng"
                v-model="form.project_description"
                placeholder="Enter project description"
              ></b-form-textarea>
            </b-form-group>
            <!-- May be useful later that's why I'm putting it in comments -->
            <!--        [TODO: remove this form part after all the data in the project list changed to json]-->
            <!-- <b-form-group
              id="input-group-platform"
              label="Project Platform:"
              label-for="input-platform"
            >
          
              <b-form-checkbox-group
                id="input-platform"
                v-model="form.project_platform"
                :options="getProjectPlatformList"
                value-field="platform_name"
                text-field="platform_name"
              ></b-form-checkbox-group>
            </b-form-group> -->
            <b-form-group
              id="input-group-platform-id"
              label="Project Platform:"
              label-for="input-platform-id"
            >
              <b-form-checkbox-group
                id="input-platform-id"
                v-model="form.project_platform_id"
                :options="getProjectPlatformList"
                value-field="id"
                text-field="platform_name"
              ></b-form-checkbox-group>
            </b-form-group>
          </div>
          <div style="background-color: #93dce6" class="p-3">
            <div class="grid-options">
              <b-form-group
                id="input-group-status"
                label="Project Status:"
                label-for="input-status"
              >
                <b-form-select
                  id="input-status"
                  v-model="form.project_status"
                  :options="getProjectStatusList"
                  value-field="status_name"
                  text-field="status_name"
                ></b-form-select>
              </b-form-group>
              <b-form-group
                id="input-group-category"
                label="Project Category:"
                label-for="input-category"
              >
                <b-form-select
                  id="input-category"
                  v-model="form.project_category"
                  :options="getProjectCategoryList"
                  value-field="category_name"
                  text-field="category_name"
                ></b-form-select>
              </b-form-group>
              <b-form-group id="input-group-priority" label="Project Priority">
                <b-form-input
                  id="input-priority"
                  v-model="form.project_priority"
                  class="noscroll"
                  type="number"
                  placeholder="Enter project priority"
                ></b-form-input>
              </b-form-group>
            </div>
            <!--TODO: project_hours - https://trello.com/c/TyYUGCH5/166-load-in-time-information-for-a-project-on-a-projects-detail -->
            <div class="grid-options">
              <b-form-group id="input-group-featured" label="Featured?">
                <b-form-radio-group
                  id="btn-radios-featured"
                  v-model="form.project_featured"
                  :options="options"
                  buttons
                  button-variant="primary"
                  name="radios-btn-default"
                ></b-form-radio-group>
              </b-form-group>
              <b-form-group
                id="input-group-published-web"
                label="Published on Website?"
              >
                <b-form-radio-group
                  id="btn-radios-published-web"
                  v-model="form.publish_website_flag"
                  :options="options"
                  buttons
                  button-variant="primary"
                  name="radios-btn-default"
                ></b-form-radio-group>
              </b-form-group>
              <b-form-group
                id="input-group-published-brochure"
                label="Published in Brochure?"
              >
                <b-form-radio-group
                  id="btn-radios-brouchure"
                  v-model="form.publish_brochure_flag"
                  :options="options"
                  buttons
                  button-variant="primary"
                  name="radios-btn-default"
                ></b-form-radio-group>
              </b-form-group>
            </div>
          </div>
          <div class="p-3">
            <div style="display: flex" class="mb-1">
              <h5>Goal 1</h5>
              <b-button
                size="sm"
                variant="primary"
                class="ml-2"
                @click="changeGoalOrder(1)"
              >
                <b-icon icon="chevron-down"></b-icon>
              </b-button>
            </div>
            <b-form-group id="input-group-project-current-goal-one">
              <b-form-textarea
                id="input-project-current-goal-one"
                v-model="form.project_current_goal_one"
                type="text"
                placeholder="Enter project goal one"
              >
              </b-form-textarea>
            </b-form-group>
            <div style="display: flex" class="mb-1">
              <h5>Goal 2</h5>
              <b-button
                size="sm"
                variant="primary"
                class="ml-2"
                @click="changeGoalOrder(3)"
              >
                <b-icon icon="chevron-down"></b-icon>
              </b-button>
              <b-button
                size="sm"
                variant="primary"
                class="ml-1"
                @click="changeGoalOrder(2)"
              >
                <b-icon icon="chevron-up"></b-icon>
              </b-button>
            </div>
            <b-form-group id="input-group-project-current-goal-two">
              <b-form-textarea
                id="input-project-current-goal-two"
                v-model="form.project_current_goal_two"
                type="text"
                placeholder="Enter project goal two"
              >
              </b-form-textarea>
            </b-form-group>
            <div style="display: flex" class="mb-1">
              <h5>Goal 3</h5>
              <b-button
                size="sm"
                variant="primary"
                class="ml-2"
                @click="changeGoalOrder(3)"
              >
                <b-icon icon="chevron-up"></b-icon>
              </b-button>
            </div>
            <b-form-group id="input-group-project-current-goal-three">
              <b-form-textarea
                id="input-project-current-goal-three"
                v-model="form.project_current_goal_three"
                type="text"
                placeholder="Enter project goal three"
              >
              </b-form-textarea>
            </b-form-group>
            <b-button variant="warning" disabled>
              <b-icon icon="plus"></b-icon> Add new Goal
            </b-button>
          </div>
          <div class="p-3" style="background-color: #93dce6">
            <edit-project-targets
              :targets="this.form.targets"
              :projectId="this.form.id"
            />
            <b-tabs pills card>
              <b-tab title="Source control" active>
                <div class="grid-links">
                  <b-form-input type="text" disabled placeholder="Gitlab">
                  </b-form-input>
                  <b-form-input
                    v-model="form.source_control_link"
                    type="text"
                    placeholder="Enter project source control link 0"
                  >
                  </b-form-input>
                  <v-btn
                    color="#E5AE2E"
                    dark
                    :disabled="
                      form.source_control_link === '' ||
                      form.source_control_link === null
                        ? true
                        : false
                    "
                    @click="GotoLink(form.source_control_link)"
                    >Go to</v-btn
                  >
                  <v-btn color="#2722A6" dark disabled>Delete</v-btn>
                </div>
                <div class="grid-links">
                  <b-form-input type="text" disabled placeholder="Gitlab Board">
                  </b-form-input>
                  <b-form-input
                    v-model="form.source_control_link1"
                    type="text"
                    placeholder="Enter project source control link 1"
                  >
                  </b-form-input>
                  <v-btn
                    color="#E5AE2E"
                    dark
                    :disabled="
                      form.source_control_link1 === '' ||
                      form.source_control_link1 === null
                        ? true
                        : false
                    "
                    @click="GotoLink(form.source_control_link1)"
                    >Go to</v-btn
                  >
                  <v-btn color="#2722A6" dark disabled>Delete</v-btn>
                </div>
                <div class="grid-links">
                  <b-form-input type="text" disabled placeholder="Link 2">
                  </b-form-input>
                  <b-form-input
                    v-model="form.source_control_link2"
                    type="text"
                    placeholder="Enter project source control link 2"
                  >
                  </b-form-input>
                  <v-btn
                    color="#E5AE2E"
                    dark
                    :disabled="
                      form.source_control_link2 === '' ||
                      form.source_control_link2 === null
                        ? true
                        : false
                    "
                    @click="GotoLink(form.source_control_link2)"
                    >Go to</v-btn
                  >
                  <v-btn color="#2722A6" dark disabled>Delete</v-btn>
                </div>

                <b-button variant="warning" disabled>
                  <b-icon icon="plus"></b-icon> Add new Link
                </b-button>
              </b-tab>
              <b-tab title="Latest Version">
                <div class="grid-links">
                  <b-form-input type="text" disabled placeholder="Version">
                  </b-form-input>
                  <b-form-input
                    v-model="form.project_latest_version"
                    type="text"
                    placeholder="Enter project latest version"
                  >
                  </b-form-input>
                  <v-btn color="#E5AE2E" dark disabled>Save</v-btn>
                  <v-btn color="#2722A6" dark disabled>Delete</v-btn>
                </div>
                <b-button variant="warning" disabled>
                  <b-icon icon="plus"></b-icon> Add new Link
                </b-button>
              </b-tab>
              <b-tab title="Software">
                <div class="grid-links">
                  <b-form-input type="text" disabled placeholder="Android">
                  </b-form-input>
                  <b-form-input
                    v-model="form.working_software_link_android"
                    type="text"
                    placeholder="Enter software link android"
                  >
                  </b-form-input>
                  <v-btn color="#E5AE2E" dark disabled>Save</v-btn>
                  <v-btn color="#2722A6" dark disabled>Delete</v-btn>
                </div>
                <div class="grid-links">
                  <b-form-input type="text" disabled placeholder="iOs">
                  </b-form-input>
                  <b-form-input
                    v-model="form.working_software_link_ios"
                    type="text"
                    placeholder="Enter software link ios"
                  >
                  </b-form-input>
                  <v-btn color="#E5AE2E" dark disabled>Save</v-btn>
                  <v-btn color="#2722A6" dark disabled>Delete</v-btn>
                </div>
                <div class="grid-links">
                  <b-form-input type="text" disabled placeholder="Web">
                  </b-form-input>
                  <b-form-input
                    v-model="form.working_software_link_web"
                    type="text"
                    placeholder="Enter software link web"
                  >
                  </b-form-input>
                  <v-btn color="#E5AE2E" dark disabled>Save</v-btn>
                  <v-btn color="#2722A6" dark disabled>Delete</v-btn>
                </div>

                <b-button variant="warning" disabled>
                  <b-icon icon="plus"></b-icon> Add new Link
                </b-button>
              </b-tab>
              <b-tab title="Management">
                <div class="grid-links">
                  <b-form-input
                    type="text"
                    disabled
                    placeholder="Project Management Link"
                  >
                  </b-form-input>
                  <b-form-input
                    v-model="form.project_management_link"
                    type="text"
                    placeholder="Enter Project Management Link"
                  >
                  </b-form-input>
                  <v-btn color="#E5AE2E" dark disabled>Save</v-btn>
                  <v-btn color="#2722A6" dark disabled>Delete</v-btn>
                </div>
                <b-button variant="warning" disabled>
                  <b-icon icon="plus"></b-icon> Add new Link
                </b-button>
              </b-tab>
              <b-tab title="XD and Other Documents">
                <div class="grid-links">
                  <b-form-input
                    type="text"
                    disabled
                    placeholder="Project software link xd"
                  >
                  </b-form-input>
                  <b-form-input
                    v-model="form.working_software_link_xd"
                    type="text"
                    placeholder="Enter software link xd"
                  >
                  </b-form-input>
                  <v-btn color="#E5AE2E" dark disabled>Save</v-btn>
                  <v-btn color="#2722A6" dark disabled>Delete</v-btn>
                </div>
                <div class="grid-links">
                  <b-form-input
                    type="text"
                    disabled
                    placeholder="Project document-and-other"
                  >
                  </b-form-input>
                  <b-form-input
                    v-model="form.document_and_other"
                    type="text"
                    placeholder="Enter documents and other"
                  >
                  </b-form-input>
                  <v-btn color="#E5AE2E" dark disabled>Save</v-btn>
                  <v-btn color="#2722A6" dark disabled>Delete</v-btn>
                </div>

                <b-button variant="warning" disabled>
                  <b-icon icon="plus"></b-icon> Add new Link
                </b-button>
              </b-tab>
            </b-tabs>
          </div>
        </b-tab>
        <b-tab
          v-for="language in localizedLanguages"
          :key="language.id"
          :title="language.language_name"
        >
          <div class="px-3">
            <b-form-group
              :id="`input-group-name-locale-${language.language_code}`"
              :label="`Project Name in ${language.language_name}`"
              :label-for="`input-name-locale-${language.language_code}`"
            >
              <b-form-input
                :id="`input-name-locale-${language.language_code}`"
                v-model="localeName[language.language_code]"
                type="text"
                placeholder="Enter project name"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              :id="`input-group-description-locale-${language.language_code}`"
              :label="`Description ${language.language_name}`"
              :label-for="`input-description-locale-${language.language_code}`"
            >
              <b-form-textarea
                :id="`input-description-locale-${language.language_code}`"
                v-model="localeDescription[language.language_code]"
                placeholder="Enter project description"
              ></b-form-textarea>
            </b-form-group>
          </div>
        </b-tab>
      </b-tabs>
      <div class="m-5" style="display: flex; justify-content: space-around">
        <v-btn color="#E5AE2E" dark type="submit">
          <v-icon left> mdi-check</v-icon>
          Submit
        </v-btn>

        <v-btn color="#E5AE2E" dark @click="closeModal($event.target)">
          <v-icon left> mdi-close</v-icon>
          Cancel
        </v-btn>

        <v-btn color="#E5AE2E" dark @click="remove">
          <v-icon left> mdi-delete</v-icon>
          Delete
        </v-btn>
      </div>
    </b-form>
  </div>
</template>
<script>
import {mapActions, mapGetters} from "vuex";
import axios from "@/services/axios.config";
import {deepCopyJSONObject} from "@/Utilites/helper";
import EditProjectTargets from "./ProjectTargets/EditProjectTargets.vue";

export default {
  components: {
    EditProjectTargets,
  },
  props: ["projectDetail", "modalId"],
  name: "EditProjectDetail",
  data() {
    return {
      file1: null,
      projectId: "",
      form: {},
      options: [
        {text: "Yes", value: true},
        {text: "No", value: false},
      ],
      localeName: {},
      localeDescription: {},
    };
  },
  computed: {
    ...mapGetters([
      "getProjectDetails",
      "getProjects",
      "getProjectPlatformList",
      "getProjectCategoryList",
      "getProjectStatusList",
      "getLanguages",
    ]),
    formValueLoaded() {
      return this.getProjectDetails;
    },
    // Languages that get their own localized tab (everything except the
    // base/English fields, which live on the "English" tab above). Driven by
    // the API language list so new languages (e.g. Spanish) appear automatically.
    localizedLanguages() {
      return this.getLanguages.filter(
        (language) => language.language_code !== "EN"
      );
    },
  },
  mounted() {
    this.form = deepCopyJSONObject(this.projectDetail);

    this.localeName = this.ensureLanguageKeys(this.form.project_name_locale);
    this.localeDescription = this.ensureLanguageKeys(
      this.form.project_description_locale
    );
    document.addEventListener("wheel", this.modalScrolled);
  },
  methods: {
    ...mapActions([
      "fetchProjectDetails",
      "deleteProject",
      "editProject",
      "showLoadingProcess",
      "closeLoading",
    ]),
    isFormDataNull(value) {
      if (value === undefined || value === null) return {};
      return value;
    },
    // Seed the locale dict with an (empty) entry for every API language so that
    // v-model bindings for languages missing from the saved data (e.g. a newly
    // added Spanish "SP" key) are reactive from first render.
    ensureLanguageKeys(value) {
      const base = {...this.isFormDataNull(value)};
      this.getLanguages.forEach((language) => {
        if (base[language.language_code] === undefined) {
          base[language.language_code] = "";
        }
      });
      return base;
    },
    async uploadImage() {
      try {
        await this.showLoadingProcess();
        let formData = new FormData();
        formData.append("image", this.file1);
        await axios
          .post("api/image/upload/", formData, {
            headers: {
              "Content-type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.form.project_image_url = response.data.data["image"];
          });
      } catch (err) {
        console.log(err);
      } finally {
        await this.closeLoading();
      }
    },
    modalScrolled() {
      if (
        document.activeElement.type === "number" &&
        document.activeElement.classList.contains("noscroll")
      ) {
        document.activeElement.blur();
      }
    },

    async remove() {
      const id = this.projectDetail.id;
      await this.showLoadingProcess();
      try {
        await this.deleteProject({id});
        this.$emit("project-content-updated");
      } catch (err) {
        console.log(err);
      } finally {
        await this.closeLoading();
        this.closeModal();
      }
    },
    async onSubmit(evt) {
      evt.preventDefault();
      const id = this.projectDetail.id;
      const oldProjectName = this.projectDetail.project_name;
      this.form.project_name_locale = this.localeName;
      this.form.project_description_locale = this.localeDescription;
      const projectForm = this.form;
      await this.showLoadingProcess();
      try {
        await this.editProject({id, projectForm, oldProjectName});
        this.$emit("project-content-updated");
        this.closeModal();
      } catch (err) {
        console.log(err);
      } finally {
        await this.closeLoading();
      }
    },
    changeGoalOrder(number) {
      let temporary = "";
      switch (number) {
        case 1:
          temporary = this.form.project_current_goal_one;
          this.form.project_current_goal_one = this.form.project_current_goal_two;
          this.form.project_current_goal_two = temporary;
          break;
        case 2:
          temporary = this.form.project_current_goal_two;
          this.form.project_current_goal_two = this.form.project_current_goal_one;
          this.form.project_current_goal_one = temporary;
          break;
        case 3:
          temporary = this.form.project_current_goal_two;
          this.form.project_current_goal_two = this.form.project_current_goal_three;
          this.form.project_current_goal_three = temporary;
          break;
      }
    },
    GotoLink(link) {
      window.open(link, "_blank").focus();
    },
    closeModal() {
      document.removeEventListener("wheel", this.modalScrolled);
      this.$bvModal.hide(this.modalId);
    },
  },
};
</script>
<style scoped>
.grid-options {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr;
  gap: 5px;
}
.grid-links {
  margin-bottom: 10px;
  display: grid;
  grid-template-columns: 2fr 4fr 1fr 1fr;
  grid-template-rows: 1fr;
  gap: 5px;
}
</style>
